import React from 'react';
import FallbackCgi from '../../../../common/cgi/FallbackCgi';
import useImage from '../../../../common/images/useImage';

const TrimCardImage = ({ cgi, trimName }) => {
  const { hasError } = useImage(cgi);

  if (hasError) {
    return <FallbackCgi fullWidth noPadding />;
  }
  return (
    <div className="grid-card__image-container">
      <img className="card__image" src={cgi} alt={trimName} />
    </div>
  );
};

export default TrimCardImage;
